import { evaluateExprNode } from './evaluate.js';
/** Zero-decimal currencies where 1 unit = 1 minor unit (no cents). https://docs.stripe.com/currencies#zero-decimal */
const ZERO_DECIMAL_CURRENCIES = new Set([
    'BIF', 'CLP', 'DJF', 'GNF', 'ISK', 'JPY', 'KMF', 'KRW',
    'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
]);
export function minorUnitMultiplier(currency) {
    return ZERO_DECIMAL_CURRENCIES.has(currency.toUpperCase()) ? 1 : 100;
}
export function calculateSubtotal(upsell, selection) {
    const m = minorUnitMultiplier(upsell.currency);
    if (upsell.mode === 'option' && selection.type === 'option') {
        return Math.round(selection.optionPrice * m);
    }
    if (upsell.mode === 'quantity' && selection.type === 'quantity') {
        const majorUnits = evaluateExprNode(upsell.quantityPricing.expr, selection.quantities);
        return Math.round(majorUnits * m);
    }
    throw new Error(`Pricing mode mismatch: upsell=${upsell.mode}, selection=${selection.type}`);
}
export function calculateTaxes(subtotalCents, taxes) {
    if (!taxes?.length)
        return [];
    return taxes.map((tax) => ({
        name: tax.name,
        amount: Math.round(subtotalCents * tax.rate),
    }));
}
export function calculateFees(subtotalCents, fees, currency) {
    if (!fees?.length)
        return [];
    const m = minorUnitMultiplier(currency);
    return fees.map((fee) => {
        if (fee.type === 'flat') {
            return { name: fee.name, amount: Math.round(fee.amount * m) };
        }
        return { name: fee.name, amount: Math.round(subtotalCents * fee.rate) };
    });
}
export function calculateTotal(upsell, selection) {
    const subtotal = calculateSubtotal(upsell, selection);
    const feeLines = calculateFees(subtotal, upsell.fees, upsell.currency);
    // BES-7708: GuestyPay taxes the fee-inclusive folio base, so tax (subtotal +
    // fees) when the host flags it; everyone else taxes the subtotal only.
    const feeTotal = feeLines.reduce((s, f) => s + f.amount, 0);
    const taxBase = upsell.taxesApplyToFees ? subtotal + feeTotal : subtotal;
    const taxLines = calculateTaxes(taxBase, upsell.taxes);
    const total = subtotal + taxLines.reduce((s, t) => s + t.amount, 0) + feeTotal;
    return { subtotal, taxLines, feeLines, total };
}
